var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Bullet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#AD80CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0278 34C25.7718 34 25.6438 33.872 25.6438 33.616V31.12H18.9238C18.6838 31.12 18.5638 31 18.5638 30.76V28.096C18.5638 27.936 18.6118 27.768 18.7078 27.592L25.4998 17.44C25.5958 17.28 25.7478 17.2 25.9558 17.2H29.3158C29.5558 17.2 29.6758 17.32 29.6758 17.56V27.808H31.0198C31.1318 27.808 31.2278 27.848 31.3078 27.928C31.3878 27.992 31.4278 28.08 31.4278 28.192V30.736C31.4278 30.848 31.3878 30.944 31.3078 31.024C31.2278 31.088 31.1318 31.12 31.0198 31.12H29.6758V33.616C29.6758 33.872 29.5478 34 29.2918 34H26.0278ZM22.4758 27.808H25.6438V23.104L22.4758 27.808Z",
    fill: "#FECC3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Bullet);
export default __webpack_public_path__ + "static/media/4-bullet.e815e4370a9e0791ac18ec3ba0e47a23.svg";
export { ForwardRef as ReactComponent };